import { ITrackRequestDemandIntoViewParams } from '../../../../types/requestDemand';
import { ITeaserEvent } from '../../../../types/teaser';
import { getViewportDimensions } from '../../../../utils/getViewportDimensions';
import { parseCookies } from '@cian/utils/lib/shared/cookie';
import { sendTeaserEvent } from '../../../../services/teaser';

export function trackBannerShow(params: ITrackRequestDemandIntoViewParams) {
  try {
    const event: ITeaserEvent = {
      user_id: params.userId,
      pageType: 'Card',
      device_type: 'desktop',
      ab_group: params.abGroup,
      viewport: getViewportDimensions(),
      cid: parseCookies(document.cookie)['_CIAN_GK'],
      items: [
        {
          announcement_id: params.offerId,
          block_type: params.blockType,
          isTeaserShow: true,
          demand_location: 'after_similar',
        },
      ],
    };

    sendTeaserEvent(params.soprApi, event);
  } catch (e) {}
}
